import React from 'react';

export const ActionCableContext = React.createContext();
